import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import { listCategories } from './thunks/marketplace-categories';
import { listProducts } from './thunks/marketplace-products';
import {
  createQuoteSet,
  getQuoteSet,
  listQuotes,
  createQuote,
  updateQuote,
  deleteQuote,
  generateQuotePdf,
  purchaseEmail,
  updateQuoteStatus,
  addQuoteProduct,
  deleteQuoteProduct,
  sendQuotePurchaseOrder,
  saveQuote,
  listSavedQuotes,
  loadQuote,
  deleteSavedQuote,
  listQuoteConversations,
  listQuoteStatus,
  getQuotePurchaseSettings,
  updateQuotePurchaseSettings,
  listQuoteOrganizations,
  exportQuote,
  getQuoteSetProperty,
} from './thunks/marketplace-quote';
import { uploadQuoteAttachments } from './thunks/marketplace-attachment-upload';
import {
  importAttachmentsReducer,
  removeImportedAttachmentReducer,
  resetCategoriesReducer,
  resetImportedAttachmentsReducer,
  resetProductsReducer,
  resetQuotesReducer,
  resetSelectedCategoryReducer,
  resetSelectedQuoteSetReducer,
  selectCategoryReducer,
  selectProductReducer,
  selectQuoteProductReducer,
  selectQuoteReducer,
  setDefaultSelectedQuoteReducer,
} from './reducers';
import { marketplaceCategoriesReducers } from './extra-reducers/marketplace-categories';
import { marketplaceProductsReducers } from './extra-reducers/marketplace-products';
import { marketplaceQuoteReducers } from './extra-reducers/marketplace-quote';
import { marketplaceAttachmentUploadReducers } from './extra-reducers/marketplace-attachment-upload';

export {
  //categories
  listCategories,
  //products
  listProducts,
  //quote set
  createQuoteSet,
  getQuoteSet,
  getQuoteSetProperty,
  //quote
  listQuotes,
  createQuote,
  updateQuote,
  deleteQuote,
  generateQuotePdf,
  purchaseEmail,
  updateQuoteStatus,
  listQuoteConversations,
  listQuoteStatus,
  exportQuote,
  //quote item
  addQuoteProduct,
  deleteQuoteProduct,
  sendQuotePurchaseOrder,
  //attachment
  uploadQuoteAttachments,
  //saved quote
  saveQuote,
  listSavedQuotes,
  loadQuote,
  deleteSavedQuote,
  // purchase settings
  getQuotePurchaseSettings,
  updateQuotePurchaseSettings,
  // quote organizations
  listQuoteOrganizations,
};

export const marketplaceSlice = createSlice({
  name: 'marketplace',
  initialState,
  reducers: {
    selectProduct: selectProductReducer,
    selectCategory: selectCategoryReducer,
    selectQuote: selectQuoteReducer,
    setDefaultSelectedQuote: setDefaultSelectedQuoteReducer,
    selectQuoteProduct: selectQuoteProductReducer,
    importAttachments: importAttachmentsReducer,
    removeImportedAttachment: removeImportedAttachmentReducer,
    resetSelectedCategory: resetSelectedCategoryReducer,
    resetProducts: resetProductsReducer,
    resetCategories: resetCategoriesReducer,
    resetSelectedQuoteSet: resetSelectedQuoteSetReducer,
    resetQuotes: resetQuotesReducer,
    resetImportedAttachments: resetImportedAttachmentsReducer,
  },
  extraReducers(builder) {
    marketplaceCategoriesReducers(builder);
    marketplaceProductsReducers(builder);
    marketplaceQuoteReducers(builder);
    marketplaceAttachmentUploadReducers(builder);
  },
});

export const {
  selectProduct,
  selectCategory,
  selectQuote,
  setDefaultSelectedQuote,
  selectQuoteProduct,
  importAttachments,
  removeImportedAttachment,
  resetSelectedCategory,
  resetProducts,
  resetCategories,
  resetSelectedQuoteSet,
  resetQuotes,
  resetImportedAttachments,
} = marketplaceSlice.actions;

export default marketplaceSlice.reducer;
